import Restaurants from "app/Restaurants/config"

const serviceProviders = {
    Restaurants
};

export default serviceProviders;
